import routeControlComponent from './route_control.component';
import deliveryManifestAll from './delivery_manifest_all'
import deliveryManifestCombined from './delivery_manifest_combined';

let routeControlModule = angular.module('routeControl', [deliveryManifestAll, deliveryManifestCombined])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/routeControl');

    $stateProvider
      .state('routeControl', {
        url: '/routeControl',
        component: 'routeControl',
        data: {
          requireLogin: true,
          requireACL: 'route_control.all'
        },
        parent: 'app',
      });
  })

  .component('routeControl', routeControlComponent)

  .name;

export default routeControlModule;


// WEBPACK FOOTER //
// ./client/app/components/route_control/index.js